import { Button, Grid, MenuItem, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { WareHouseApi } from "api/WareHouseApi";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import LoaderDrop from "utils/LoaderDrop";
import useLoader from "utils/useLoader";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from "@mui/material";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";

function WareHouseReport() {
  const { start, stop, loading } = useLoader();
  const printRef = useRef();
  const [warehouses, setWarehouses] = useState([]);
  const [category, setCategory] = useState([]);

  const [report, setReport] = useState([]);
  const [selectedItems, setSelectedItems] = useState({
    warehouse: "ALL",
    category: "ALL",
    type: "ALL",
  });
  const [summary, setSummary] = useState({
    netTotal: 0,
    netAmount: 0,
  });
  const [search, setSearch] = useState("");
  const types = [{ type: "ALL" }, { type: "-VE" }, { type: "+VE" }];

  const columns = [
    { title: "Sl No" },
    { title: "Items" },
    { title: "Unit" },
    { title: "Stock(in base unit)" },
    { title: "Cost" },
    { title: "Total Amount" },
  ];

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Warehouse Stock Report",
  });

  useEffect(() => {
    fetchWareHouses();
    fetchCategorys();
  }, []);

  const fetchWareHouses = async () => {
    start();
    try {
      const res = await WareHouseApi.getWareHouses();
      if (res?.success) {
        const all = {
          Typ: "ALL",
        };
        const filteredWarehouses = (res?.data || []).filter(
          (item) => item?.Typ !== "MAIN",
        );

        setWarehouses([all, ...filteredWarehouses]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      stop();
    }
  };
  const fetchCategorys = async () => {
    start();
    try {
      const res = await WareHouseApi.getCategory();
      if (res?.success) {
        const all = {
          Size: "ALL",
        };
        setCategory([all, ...(res?.data || [])]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      stop();
    }
  };
  const getWarehouseStock = async () => {
    start();
    try {
      const res = await WareHouseApi.getGodownStock(selectedItems);
      if (res?.success) {
        setReport(res?.data || []);

        setSummary({
          netTotal: res?.summary?.netTotal || 0,
          netAmount: res?.summary?.netAmount || 0,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      stop();
    }
  };

  const filteredReport = report.filter((item) =>
    item?.item?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div>
      <LoaderDrop start={loading} />
      <Box bgcolor={"#FFF"} p={2} borderRadius={1.5}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start"
        >
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              size="small"
              label="Search Item"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ width: 320 }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              size="small"
              label="Godown"
              value={selectedItems.warehouse}
              onChange={(e) =>
                setSelectedItems((prev) => ({
                  ...prev,
                  warehouse: e.target.value,
                }))
              }
              InputLabelProps={{ shrink: true }}
            >
              {warehouses.map((item, index) => (
                <MenuItem key={index} value={item?.Typ}>
                  {item?.Typ}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              size="small"
              label="Category"
              value={selectedItems.category}
              onChange={(e) =>
                setSelectedItems((prev) => ({
                  ...prev,
                  category: e.target.value,
                }))
              }
              InputLabelProps={{ shrink: true }}
            >
              {category.map((item, index) => (
                <MenuItem key={index} value={item?.Size}>
                  {item?.Size}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={1}>
            <TextField
              select
              fullWidth
              size="small"
              label="Type"
              value={selectedItems.type}
              onChange={(e) =>
                setSelectedItems((prev) => ({
                  ...prev,
                  type: e.target.value,
                }))
              }
              InputLabelProps={{ shrink: true }}
            >
              {types.map((item, index) => (
                <MenuItem key={index} value={item?.type}>
                  {item?.type}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              fullWidth
              onClick={getWarehouseStock}
              sx={{
                bgcolor: "#4527a0",
                color: "#FFF",
                "&:hover": {
                  outline: "1px solid #4527a0",
                  color: "#4527a0",
                },
              }}
            >
              Process
            </Button>
          </Grid>
          <Grid item xs={12} md={1}>
            <Button
              fullWidth
              onClick={handlePrint}
              sx={{
                bgcolor: "#2d3c54",
                color: "#FFF",
                "&:hover": {
                  outline: "1px solid #2d3c54",
                  color: "#2d3c54",
                },
              }}
            >
              Print
            </Button>
          </Grid>
        </Grid>

        <Box mt={3} ref={printRef}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((item, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        fontWeight: 700,
                        bgcolor: "#f5f5f5",
                      }}
                    >
                      {item.title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredReport?.length > 0 ? (
                  filteredReport.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>

                      <TableCell>{item?.item}</TableCell>

                      <TableCell>{item?.stock}</TableCell>

                      <TableCell>
                        {Number(item?.totalQty || 0).toFixed(2)}
                      </TableCell>

                      <TableCell>
                        {Number(item?.cost || 0).toFixed(2)}
                      </TableCell>

                      <TableCell>
                        {Number(item?.amount || 0).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <>
                <TableRow
                  sx={{
                    bgcolor: "#f5f5f5",
                  }}
                >
                  <TableCell
                    colSpan={3}
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    Total
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    {Number(summary?.netTotal || 0).toFixed(2)}
                  </TableCell>

                  <TableCell></TableCell>

                  <TableCell
                    sx={{
                      fontWeight: 700,
                    }}
                  >
                    {Number(summary?.netAmount || 0).toFixed(2)}
                  </TableCell>
                </TableRow>
              </>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </div>
  );
}

export default WareHouseReport;
